import React from 'react';
import CustomerDataForm from '../components/CustomerDataForm';

const Home = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white rounded-lg shadow-lg p-8 border-l-4 border-blue-600">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Willkommen bei Nadine Rau und Mike Trepte
          </h1>
          
          {/* Bilder von Nadine und Mike */}
          <div className="flex justify-center gap-8 mb-6">
            <div className="text-center">
              <img 
                src="https://github.com/mike3011/Bilder/blob/main/Bild_Nadine_Rau_freigestellt.png?raw=true"
                alt="Nadine Rau"
                className="w-24 h-24 rounded-full object-cover border-2 border-gray-200"
              />
              <p className="text-xs text-gray-500 mt-1">Nadine Rau</p>
            </div>
            <div className="text-center">
              <img 
                src="https://github.com/mike3011/Bilder/blob/main/Bild_Mike%20-%20bearbeitet.png?raw=true"
                alt="Mike Trepte"
                className="w-24 h-24 rounded-full object-cover border-2 border-gray-200"
              />
              <p className="text-xs text-gray-500 mt-1">Mike Trepte</p>
            </div>
          </div>
          
          <div className="bg-blue-50 p-4 rounded-lg mb-6 border border-blue-200">
            <p className="text-gray-700 leading-relaxed">
              Hier verwalten Sie Ihre Kundendaten, Rechnungsanschrift und rechtlichen Zustimmungen, damit Sie mit Nadine und Mike rechtssicher zusammenarbeiten können.
            </p>
          </div>
          <p className="text-gray-600 leading-relaxed">
            Diese Seite dient der Datenerfassung und Datenaktualisierung. Ihre Angaben werden verschlüsselt übertragen und direkt in unserem deutschen System gespeichert.
          </p>
        </div>
        <CustomerDataForm />
      </div>
    </div>
  );
};

export default Home;